import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import i18n from '@/lang';
import '@/assets/fontello/css/fontello.css';
import { WOW } from 'wowjs';
import animated from 'wowjs/css/libs/animate.css';

Vue.config.productionTip = false;
Vue.use(animated);
Vue.prototype.$wow = new WOW({
	boxClass: 'wow',
	animateClass: 'animated',
	offset: 0,
	mobile: true,
	live: true,
});

new Vue({
	vuetify,
	i18n,
	render: (h) => h(App),
}).$mount('#app');
